import { GetIslandByIdQuery } from 'queries/islands/generated'
import { useMemo } from 'react'

import { useIslandByIdSubgraph } from './subgraph/islands'

type IslandEntity = NonNullable<GetIslandByIdQuery['kodiakVault']>

export type SubgraphIsland = {
  token0: IslandEntity['_token0']
  token1: IslandEntity['_token1']
  token0Amount: IslandEntity['_token0Amount']
  token1Amount: IslandEntity['_token1Amount']
  token0AmountUSD: IslandEntity['_token0AmountUSD']
  token1AmountUSD: IslandEntity['_token1AmountUSD']
} & IslandEntity

export interface UsePrepareSubgraphIslandResult {
  isLoading: boolean
  isFetching: boolean
  isUninitialized: boolean
  isError: boolean
  island: SubgraphIsland | null
  error: any
  refetch: () => void
}

// maximum number of blocks past which we consider the data stale
function prepareIsland(island: IslandEntity): SubgraphIsland {
  return {
    ...island,
    name: island.name,
    symbol: island.symbol,
    token0: island._token0,
    token1: island._token1,
    token0Amount: island._token0Amount,
    token1Amount: island._token1Amount,
    token0AmountUSD: island._token0AmountUSD,
    token1AmountUSD: island._token1AmountUSD,
  }
}

export function useIsland(islandId: string | undefined): UsePrepareSubgraphIslandResult {
  const {
    data,
    isLoading,
    isFetching,
    isError: isQueryError,
    refetch,
    error: queryError,
  } = useIslandByIdSubgraph(islandId?.toLowerCase() ?? '')

  const isUninitialized = !islandId

  const preparedData: SubgraphIsland | null = useMemo(() => {
    if (data) {
      return prepareIsland(data)
    }
    return null
  }, [data])

  return {
    isLoading,
    isFetching,
    isUninitialized,
    isError: isQueryError,
    error: isQueryError ? queryError : null,
    island: preparedData,
    refetch,
  }
}
